import React from "react";
import { Box, Stepper, Step, StepLabel, Typography, Paper, Grid, Chip } from "@mui/material";

const JobDetailStepper = ({ job }) => {
	let activeStep = 0;
	const steps = job.progerss || []; // Handles the "progerss" typo returned from API

	// Calculate active step based on status
	for (let i = 0; i < steps.length; i++) {
		const status = steps[i].status?.toUpperCase();
		if (status === "SUCCESS" || status === "COMPLETED") {
			activeStep = i + 1;
		} else if (status === "IN_PROGRESS" || status === "FAILED") {
			activeStep = i;
			break;
		}
	}

	return (
		<Box sx={{ width: "100%" }}>
			<Paper elevation={0} sx={{ p: { xs: 2, md: 4 }, mb: 3, border: "none", bgcolor: "action.hover", borderRadius: 2, overflowX: "auto" }}>
				<Stepper activeStep={activeStep} alternativeLabel>
					{steps.map((step, index) => {
						const labelProps = {};
						if (step.status?.toUpperCase() === "FAILED") {
							labelProps.error = true;
						}
						return (
							<Step key={index}>
								<StepLabel {...labelProps}>
									{step.step}
									<Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
										{step.timestamp}
									</Typography>
								</StepLabel>
							</Step>
						);
					})}
				</Stepper>
			</Paper>

			<Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, border: "1px solid", borderColor: "divider", borderRadius: 2, bgcolor: "transparent" }}>
				<Typography
					variant="subtitle2"
					fontWeight="600"
					color="text.secondary"
					sx={{ mb: 3, textTransform: "uppercase", letterSpacing: "0.5px" }}>
					Job Information
				</Typography>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6} md={3}>
						<Typography variant="body2" color="text.secondary">
							Job ID
						</Typography>
						<Typography variant="body1" fontWeight="600" sx={{ wordBreak: "break-all" }}>
							{job.job_id}
						</Typography>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<Typography variant="body2" color="text.secondary">
							Type
						</Typography>
						<Typography variant="body1" fontWeight="600">
							{job.job_type}
						</Typography>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<Typography variant="body2" color="text.secondary">
							Created By
						</Typography>
						<Typography variant="body1" fontWeight="600">
							{job.created_by}
						</Typography>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<Typography variant="body2" color="text.secondary">
							Execution Date
						</Typography>
						<Typography variant="body1" fontWeight="600">
							{job.createdAt ? new Date(job.createdAt).toLocaleString() : "-"}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
		</Box>
	);
};

export default JobDetailStepper;
